import type * as React from "react";

import "./FormComponent.scss";

interface FormComponentProps {
  editorId: string;
  editorValid: boolean;
  label: string;
  children: React.ReactNode;
  validationMessage: string;
  required?: boolean;
  testId?: string;
}

export const FormComponent = (props: FormComponentProps) => (
  <div className="k-form-field" data-testid={props.testId ?? `${props.editorId}-field`}>
    <label
      htmlFor={props.editorId}
      data-testid={`${props.testId ?? props.editorId}-label`}
      className={`k-label ${!props.editorValid ? "k-text-error" : ""}`}
    >
      {props.label}
      {props.required ?
        <span className="required-field-mark">*</span>
      : null}
    </label>
    {props.children}
    {!props.editorValid && (
      <div
        role="alert"
        className="k-form-error k-text-start"
        data-testid={`${props.testId ?? props.editorId}-error`}
      >
        {props.validationMessage}
      </div>
    )}
  </div>
);
